import { IIllustration } from '../Illustration.model';

const Onboarding = ({ width, height }: IIllustration) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 378 272"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1202_6305)">
      <path
        opacity="0.1"
        d="M372.014 182.864C363.247 201.037 345.446 213.205 326.997 221.223C302.161 232.022 274.81 236.304 247.835 234.493C243.105 234.177 238.392 233.671 233.696 232.977C217.381 230.581 201.474 225.923 186.431 219.137C182.089 217.171 177.835 215.024 173.668 212.698C166.709 208.82 160.041 204.436 153.718 199.58C152.128 198.36 150.56 197.108 149.013 195.825C147.941 194.936 146.878 194.027 145.799 193.145C143.522 191.283 141.18 189.515 138.566 188.192C137.778 187.792 136.969 187.433 136.144 187.117C127.869 183.952 118.326 185.146 109.711 187.614C103.148 189.492 96.7596 192.08 90.213 193.898C87.3011 194.738 84.334 195.373 81.3336 195.795C74.6316 196.649 67.8254 196.049 61.3739 194.034L60.8229 193.861C59.899 193.569 58.9828 193.25 58.0743 192.902L57.5232 192.69C56.6433 192.347 55.7821 191.981 54.9396 191.592L54.3885 191.34C53.5086 190.929 52.6474 190.494 51.8049 190.036C51.5013 189.877 51.2011 189.704 50.9041 189.542C46.1106 186.85 41.7534 183.439 37.9826 179.427C37.8737 179.317 37.7714 179.205 37.6526 179.095C37.128 178.525 36.6132 177.944 36.115 177.35C35.9302 177.131 35.7454 176.912 35.5639 176.687C34.9733 175.96 34.4025 175.22 33.8514 174.461C33.7689 174.351 33.6897 174.238 33.6105 174.129C31.3571 170.995 29.4891 167.599 28.0473 164.014C28.0011 163.905 27.9582 163.792 27.9186 163.682C27.4787 162.546 27.0772 161.388 26.7142 160.209C26.5657 159.718 26.4239 159.214 26.2985 158.723C26.2556 158.577 26.216 158.428 26.1797 158.282C24.3583 151.073 24.1504 143.579 24.1504 136.128V133.524C24.2032 121.471 24.388 109.213 26.1566 97.327C26.162 97.2443 26.1741 97.1622 26.1929 97.0815C26.7836 93.0797 27.5888 89.1129 28.6049 85.1985C29.6671 81.0908 31.0246 77.0661 32.6668 73.1562C36.7353 63.5356 42.6516 54.7809 49.2213 46.6664C65.779 26.2476 87.4809 9.10639 112.882 2.69047C140.252 -4.21975 170.672 2.40185 192.734 20.0738C199.465 25.4614 205.513 31.8408 213.073 35.971C219.672 39.5671 227.397 41.0566 234.465 38.2269C240.305 35.9047 244.106 34.727 250.666 35.0819C264.252 35.8576 277.646 38.6813 290.397 43.4585C290.912 43.6476 291.427 43.8433 291.938 44.039C325.169 56.8078 353.724 82.2028 368.573 114.836C368.967 115.699 369.348 116.568 369.718 117.444C378.581 138.234 381.772 162.601 372.014 182.864Z"
        fill="#58A765"
      />
      <path
        opacity="0.1"
        d="M39.6949 246.482C55.7827 246.482 68.8244 244.376 68.8244 241.778C68.8244 239.18 55.7827 237.074 39.6949 237.074C23.6071 237.074 10.5654 239.18 10.5654 241.778C10.5654 244.376 23.6071 246.482 39.6949 246.482Z"
        fill="#58A765"
      />
      <path
        opacity="0.1"
        d="M301.015 272C329.541 272 352.665 269.742 352.665 266.958C352.665 264.173 329.541 261.915 301.015 261.915C272.49 261.915 249.366 264.173 249.366 266.958C249.366 269.742 272.49 272 301.015 272Z"
        fill="#58A765"
      />
      <path
        d="M347.778 35.7455H42.4436C40.1674 35.7455 38.3223 37.6006 38.3223 39.889V210.19C38.3223 212.478 40.1674 214.333 42.4436 214.333H347.778C350.054 214.333 351.9 212.478 351.9 210.19V39.889C351.9 37.6006 350.054 35.7455 347.778 35.7455Z"
        fill="url(#paint0_linear_1202_6305)"
      />
      <path
        d="M347.316 38.2563H42.9418C40.6657 38.2563 38.8206 40.1114 38.8206 42.3998V209.595C38.8206 211.884 40.6657 213.739 42.9418 213.739H347.316C349.592 213.739 351.438 211.884 351.438 209.595V42.3998C351.438 40.1114 349.592 38.2563 347.316 38.2563Z"
        fill="white"
      />
      <path
        d="M347.316 38.2563H42.9418C40.6657 38.2563 38.8206 40.1114 38.8206 42.3998V209.595C38.8206 211.884 40.6657 213.739 42.9418 213.739H347.316C349.592 213.739 351.438 211.884 351.438 209.595V42.3998C351.438 40.1114 349.592 38.2563 347.316 38.2563Z"
        fill="white"
      />
      <path
        opacity="0.04"
        d="M347.316 38.2563H42.9418C40.6657 38.2563 38.8206 40.1114 38.8206 42.3998V209.595C38.8206 211.884 40.6657 213.739 42.9418 213.739H347.316C349.592 213.739 351.438 211.884 351.438 209.595V42.3998C351.438 40.1114 349.592 38.2563 347.316 38.2563Z"
        fill="white"
      />
      <path
        d="M349.851 36.243H40.4077C39.9868 36.243 39.5831 36.4111 39.2854 36.7104C38.9878 37.0096 38.8206 37.4155 38.8206 37.8387V44.5831H351.415V37.8387C351.415 37.4195 351.251 37.0171 350.958 36.7185C350.665 36.4199 350.267 36.2491 349.851 36.243Z"
        fill="#5A5773"
      />
      <path
        d="M45.0635 42.569C46.248 42.569 47.2083 41.6036 47.2083 40.4126C47.2083 39.2217 46.248 38.2563 45.0635 38.2563C43.879 38.2563 42.9187 39.2217 42.9187 40.4126C42.9187 41.6036 43.879 42.569 45.0635 42.569Z"
        fill="white"
      />
      <path
        d="M50.8379 42.569C52.0224 42.569 52.9827 41.6036 52.9827 40.4126C52.9827 39.2217 52.0224 38.2563 50.8379 38.2563C49.6534 38.2563 48.6931 39.2217 48.6931 40.4126C48.6931 41.6036 49.6534 42.569 50.8379 42.569Z"
        fill="white"
      />
      <path
        d="M56.6123 42.569C57.7969 42.569 58.7571 41.6036 58.7571 40.4126C58.7571 39.2217 57.7969 38.2563 56.6123 38.2563C55.4278 38.2563 54.4675 39.2217 54.4675 40.4126C54.4675 41.6036 55.4278 42.569 56.6123 42.569Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M148.462 60.268H64.5681V67.427H148.462V60.268Z"
        fill="#58A765"
      />
      <path
        opacity="0.1"
        d="M325.691 88.9734H64.5681V199.099H325.691V88.9734Z"
        fill="#5A5773"
      />
      <path
        opacity="0.1"
        d="M217.448 96.1557H212.987V87.4242C212.987 77.5714 205.173 69.3806 195.373 69.2313C190.623 69.1818 186.048 71.0311 182.654 74.3725C179.26 77.7138 177.325 82.2737 177.274 87.0493V96.1557H172.813C170.842 96.1618 168.953 96.9519 167.559 98.3535C166.165 99.7551 165.379 101.654 165.373 103.636V139.538C165.379 141.52 166.165 143.419 167.559 144.821C168.953 146.222 170.842 147.012 172.813 147.019H217.448C219.419 147.013 221.309 146.223 222.702 144.822C224.096 143.42 224.881 141.52 224.885 139.538V103.636C224.881 101.654 224.096 99.7546 222.702 98.3527C221.309 96.9509 219.419 96.1609 217.448 96.1557ZM197.742 119.494V132.365C197.747 133.047 197.494 133.704 197.035 134.204C196.575 134.705 195.943 135.01 195.268 135.059C194.576 135.092 193.9 134.847 193.389 134.378C192.877 133.91 192.571 133.256 192.539 132.561C192.539 132.521 192.539 132.478 192.539 132.438V119.5C191.332 118.909 190.36 117.923 189.781 116.704C189.203 115.486 189.053 114.106 189.355 112.79C189.657 111.475 190.394 110.301 191.445 109.46C192.496 108.62 193.799 108.162 195.142 108.162C196.485 108.162 197.789 108.62 198.84 109.46C199.891 110.301 200.627 111.475 200.929 112.79C201.231 114.106 201.081 115.486 200.503 116.704C199.925 117.923 198.953 118.909 197.746 119.5L197.742 119.494ZM207.786 96.1557H182.471V87.182C182.471 83.8096 183.804 80.5753 186.176 78.1906C188.548 75.8059 191.765 74.4662 195.119 74.4662C198.473 74.4662 201.69 75.8059 204.062 78.1906C206.434 80.5753 207.767 83.8096 207.767 87.182L207.786 96.1557Z"
        fill="black"
      />
      <path
        d="M217.448 95.492H212.987V86.7605C212.987 76.9077 205.173 68.7169 195.373 68.5676C190.623 68.5181 186.048 70.3674 182.654 73.7088C179.26 77.0501 177.325 81.61 177.274 86.3856V95.492H172.813C170.842 95.4981 168.953 96.2882 167.559 97.6898C166.165 99.0914 165.379 100.991 165.373 102.973V138.874C165.379 140.856 166.165 142.755 167.559 144.157C168.953 145.559 170.842 146.349 172.813 146.355H217.448C219.419 146.35 221.309 145.56 222.702 144.158C224.096 142.756 224.881 140.856 224.885 138.874V102.973C224.881 100.991 224.096 99.0909 222.702 97.689C221.309 96.2872 219.419 95.4972 217.448 95.492ZM197.742 118.83V131.702C197.747 132.383 197.494 133.04 197.035 133.541C196.575 134.041 195.943 134.347 195.268 134.396C194.576 134.428 193.9 134.183 193.389 133.715C192.877 133.246 192.571 132.593 192.539 131.898C192.539 131.858 192.539 131.815 192.539 131.775V118.837C191.332 118.245 190.36 117.259 189.781 116.041C189.203 114.822 189.053 113.442 189.355 112.126C189.657 110.811 190.394 109.637 191.445 108.796C192.496 107.956 193.799 107.498 195.142 107.498C196.485 107.498 197.789 107.956 198.84 108.796C199.891 109.637 200.627 110.811 200.929 112.126C201.231 113.442 201.081 114.822 200.503 116.041C199.925 117.259 198.953 118.245 197.746 118.837L197.742 118.83ZM207.786 95.492H182.471V86.5183C182.471 83.1459 183.804 79.9116 186.176 77.5269C188.548 75.1422 191.765 73.8026 195.119 73.8026C198.473 73.8026 201.69 75.1422 204.062 77.5269C206.434 79.9116 207.767 83.1459 207.767 86.5183L207.786 95.492Z"
        fill="#58A765"
      />
      <path
        opacity="0.1"
        d="M325.69 78.3745H299.26V84.6478H325.69V78.3745Z"
        fill="#5A5773"
      />
      <path d="M40.632 151.67H38.7578V194.1H40.632V151.67Z" fill="#535461" />
      <path
        d="M52.412 193.971L52.2932 195.881L52.1282 198.579L52.0589 199.703L51.8939 202.404L51.8213 203.528L51.6563 206.225L49.7656 236.902C49.685 238.222 49.1065 239.461 48.1482 240.367C47.1898 241.274 45.9238 241.778 44.6082 241.778H34.7818C33.4666 241.778 32.2009 241.273 31.2431 240.367C30.2853 239.461 29.7076 238.221 29.6277 236.902L27.7172 206.225L27.5522 203.528L27.483 202.404L27.3312 199.71L27.2619 198.585L27.0969 195.888L26.9781 193.977C26.9562 193.625 27.0036 193.271 27.1177 192.937C27.2317 192.603 27.4101 192.295 27.6427 192.03C27.8753 191.766 28.1576 191.55 28.4733 191.395C28.7889 191.24 29.1319 191.149 29.4826 191.128H29.6508H49.7425C50.4511 191.128 51.1308 191.41 51.6324 191.913C52.1341 192.416 52.4168 193.099 52.4186 193.811C52.4186 193.851 52.4153 193.911 52.412 193.971Z"
        fill="#3F3D56"
      />
      <path
        d="M52.2931 195.882L52.1281 198.579H27.2585L27.0935 195.882H52.2931Z"
        fill="#9D9CB5"
      />
      <path
        d="M52.0589 199.703L51.8939 202.403H27.4962L27.3279 199.703H52.0589Z"
        fill="#9D9CB5"
      />
      <path
        d="M51.8213 203.528L51.6563 206.225H27.7337L27.5654 203.528H51.8213Z"
        fill="#9D9CB5"
      />
      <path
        d="M24.235 167.573C35.1503 175.512 39.6973 187.933 39.6973 187.933C39.6973 187.933 26.5415 187.478 15.6097 179.539C4.6779 171.601 0.147461 159.18 0.147461 159.18C0.147461 159.18 13.3164 159.635 24.235 167.573Z"
        fill="#58A765"
      />
      <path
        d="M0.164307 159.18C0.164307 159.18 13.8183 166.81 18.197 173.114C22.5756 179.417 39.6976 187.936 39.6976 187.936"
        stroke="#535461"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M31.2774 151.607C37.2168 155.919 39.6949 162.687 39.6949 162.687C39.6949 162.687 32.5346 162.441 26.5919 158.119C20.6492 153.796 18.1777 147.038 18.1777 147.038C18.1777 147.038 25.338 147.254 31.2774 151.607Z"
        fill="#58A765"
      />
      <path
        d="M18.1777 147.009C18.1777 147.009 25.6086 151.156 27.9909 154.593C30.3733 158.03 39.6949 162.661 39.6949 162.661"
        stroke="#535461"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M48.33 162.316C41.503 169.856 40.061 179.709 40.061 179.709C40.061 179.709 49.6829 177.337 56.5066 169.797C63.3303 162.256 64.7755 152.4 64.7755 152.4C64.7755 152.4 55.1537 154.772 48.33 162.316Z"
        fill="#58A765"
      />
      <path
        d="M64.7755 152.4C64.7755 152.4 55.8862 160.13 53.626 165.457C51.3657 170.785 40.061 179.722 40.061 179.722"
        stroke="#535461"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M290.41 263.196H295.512L297.94 243.407H290.41V263.196Z"
        fill="#FFB8B8"
      />
      <path
        d="M289.11 261.52H299.161C300.86 261.52 302.489 262.198 303.69 263.406C304.891 264.613 305.566 266.251 305.566 267.959V268.168H289.11V261.52Z"
        fill="#2F2E41"
      />
      <path
        d="M307.569 263.196H312.67L315.098 243.407H307.569V263.196Z"
        fill="#FFB8B8"
      />
      <path
        d="M306.269 261.52H316.319C318.018 261.52 319.647 262.198 320.848 263.406C322.049 264.613 322.724 266.251 322.724 267.959V268.168H306.269V261.52Z"
        fill="#2F2E41"
      />
      <path
        d="M298.432 193.698L299.656 256.481L289.754 255.864L282.884 215.875L280.713 188.609L298.432 193.698Z"
        fill="#2F2E41"
      />
      <path
        d="M315.428 183.159L316.814 257.47L305.265 257.138L302.771 212.979L298.432 196.983L280.713 188.619L283.606 168.625L309.641 168.264L315.428 183.159Z"
        fill="#2F2E41"
      />
      <path
        d="M295.515 116.632C300.406 116.632 304.371 112.645 304.371 107.728C304.371 102.81 300.406 98.8236 295.515 98.8236C290.624 98.8236 286.659 102.81 286.659 107.728C286.659 112.645 290.624 116.632 295.515 116.632Z"
        fill="#FFB8B8"
      />
      <path
        d="M302.86 120.38L304.216 122.446L307.833 132.624L304.939 172.251L287.946 172.616L285.774 127.17L290.321 121.461L302.86 120.38Z"
        fill="#CCCCCC"
      />
      <path
        d="M278.908 128.262L276.014 127.901C276.014 127.901 275.291 128.262 274.928 130.81C274.566 133.358 270.243 155.893 270.243 155.893L276.027 183.521L282.534 174.796L278.558 159.536L282.534 144.275L278.908 128.262Z"
        fill="#2F2E41"
      />
      <path
        d="M315.788 127.901H317.956L323.381 157.346L318.319 180.25L313.257 171.886L314.702 162.8L313.98 154.802L311.449 150.074L315.788 127.901Z"
        fill="#2F2E41"
      />
      <path
        d="M300.748 107.727L299.138 107.322C299.138 107.322 297.93 100.442 295.112 101.251C292.295 102.061 285.052 102.87 285.052 99.6323C285.052 96.3945 291.892 93.5614 295.918 93.9661C299.943 94.3708 305.084 95.7144 306.384 101.656C308.466 111.18 302.095 113.599 302.095 113.599L302.203 113.267C302.502 112.299 302.524 111.267 302.266 110.287C302.009 109.307 301.483 108.42 300.748 107.727Z"
        fill="#2F2E41"
      />
      <path
        d="M276.374 127.9L287.945 123.173L290.658 121.183L298.795 157.343L302.58 120.091L317.586 127.907L312.525 152.629L311.819 162.073L313.987 169.703C313.987 169.703 321.576 175.157 319.048 180.983C316.521 186.808 313.627 187.163 313.627 187.163C313.627 187.163 301.326 175.522 300.6 172.616C299.874 169.71 298.792 164.618 298.792 164.618C298.792 164.618 292.644 187.883 285.411 187.508C278.178 187.133 278.178 179.51 278.178 179.51L279.99 171.511L282.884 163.151L281.439 149.334L276.374 127.9Z"
        fill="#2F2E41"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1202_6305"
        x1="195.109"
        y1="214.33"
        x2="195.109"
        y2="35.7422"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#808080" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
        <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
      </linearGradient>
      <clipPath id="clip0_1202_6305">
        <rect width="378" height="272" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Onboarding;
